import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { persistAppsFlyerParams } from '@/utils/appsFlyerParams';
import { isInWebView } from '@/hooks/useWebViewMessaging';

/**
 * Компонент для отслеживания и сохранения AppsFlyer параметров на уровне всего приложения.
 * Сохраняет параметры af_*, pid, c и clickid из query string при любом переходе между страницами,
 * но только если приложение открыто не в вебвью.
 */
export function AppsFlyerParamsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Сохраняем AF параметры только если приложение открыто не в вебвью
    if (!isInWebView()) {
      // Сохраняем параметры из текущего URL при любом переходе
      persistAppsFlyerParams(location.search);
    }
  }, [location.search]);

  // Также сохраняем параметры при первой загрузке приложения из window.location.search
  useEffect(() => {
    if (!isInWebView() && typeof window !== 'undefined') {
      const initialSearch = window.location.search;
      if (initialSearch) {
        persistAppsFlyerParams(initialSearch);
      }
    }
  }, []); // Выполняется только при монтировании

  return null;
}
